import React from 'react'

import {
  BackButton, Container, Header, M,
} from './styles'

import ContractorCard from '../../../components/contractor-card'
import Icon from '../../../components/icon'

import { HiringProps } from './props'

const Hiring = ({ tableDataAll }: HiringProps): JSX.Element => (
  <Container>
    <Header>
      <BackButton to="/home">
        <Icon name="arrow-left-line" />
      </BackButton>
      <span>Meu histórico de contratações</span>
    </Header>
    <M>
      {tableDataAll.map((contractor: any) => (
        <ContractorCard
          key={`contracted-by-${contractor.id}`}
          imgUrl={
            contractor.document.find((doc: any) => doc.url.startsWith('images/'))?.url
          }
          name={contractor.name}
          city={contractor.address.city}
          availability={contractor.availability.join(', ')}
          chatId={contractor.contractorId}
          hasNewMessage={contractor.hasNewMessage}
        />
      ))}
    </M>
  </Container>
)
export default Hiring
